import React from 'react';
import queryBuilder from './query-builder';
import savedQueries from './saved-queries';
import dashboards from './dashboards';
import otherPrivatePages from './other-private-pages';
import { DATASOURCE_URL_PATH, DATASOURCES_URL_PATH } from './paths';

const TrevorApp = React.lazy(() => import('@/containers/TrevorApp'));
const DatasourcesContainer = React.lazy(() => import('@/views/Datasources'));
const DatasourcesPage = React.lazy(
  () => import('@/containers/DatasourcesPage'),
);

export default {
  path: DATASOURCES_URL_PATH,
  element: <DatasourcesContainer />,
  children: [
    {
      index: true,
      element: <DatasourcesPage />,
    },
    {
      path: DATASOURCE_URL_PATH,
      element: <TrevorApp />,
      children: [queryBuilder, savedQueries, dashboards, ...otherPrivatePages],
    },
  ],
};
